var _path, _path2, _g, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconDocumentCheck(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 57,
    height: 56,
    viewBox: "0 0 57 56",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.9167 4C8.37284 4 5.5 6.87284 5.5 10.4167V38.4167C5.5 41.9605 8.37284 44.8333 11.9167 44.8333H32.9167C36.4605 44.8333 39.3333 41.9605 39.3333 38.4167V21.8272C39.3333 20.8025 38.9481 19.8153 38.2541 19.0615L25.6012 5.31767C24.828 4.47784 23.7386 4 22.597 4H11.9167Z",
    fill: "#A9D1FF"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_17809_9319",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 5,
    y: 4,
    width: 35,
    height: 41
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.9167 4C8.37284 4 5.5 6.87284 5.5 10.4167V38.4167C5.5 41.9605 8.37284 44.8333 11.9167 44.8333H32.9167C36.4605 44.8333 39.3333 41.9605 39.3333 38.4167V21.8272C39.3333 20.8025 38.9481 19.8153 38.2541 19.0615L25.6012 5.31767C24.828 4.47784 23.7386 4 22.597 4H11.9167Z",
    fill: "#166DD7"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_17809_9319)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M27.7358 0.584633C26.5912 -0.938223 24.167 -0.128691 24.167 1.77625V19.5101C24.167 20.6077 25.0584 21.4965 26.1559 21.4934L39.4563 21.4558C41.089 21.4512 42.0171 19.5861 41.0362 18.2809L27.7358 0.584633Z",
    fill: "#166DD7"
  }))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M39.3636 52.7273C46.468 52.7273 52.2273 46.968 52.2273 39.8636C52.2273 32.7593 46.468 27 39.3636 27C32.2593 27 26.5 32.7593 26.5 39.8636C26.5 46.968 32.2593 52.7273 39.3636 52.7273Z",
    fill: "#166DD7",
    stroke: "white",
    strokeWidth: 2
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M46.2747 35.6518C46.7582 36.0795 46.8035 36.8182 46.3757 37.3017L39.7316 44.8124C39.2645 45.3405 38.4593 45.3939 37.9266 44.9321L33.6309 41.2092C33.1431 40.7864 33.0903 40.0483 33.5131 39.5604C33.9359 39.0726 34.6741 39.0199 35.1619 39.4427L38.6707 42.4836L44.6248 35.7528C45.0526 35.2693 45.7912 35.2241 46.2747 35.6518Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconDocumentCheck);
export default __webpack_public_path__ + "static/media/icon-document-check.4cd6d906d665fb893cfd1375287f1bc7.svg";
export { ForwardRef as ReactComponent };